<template>
  <div class="main">
    <div class="register">
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        class="form"
        name="registUserForm"
        @submit.prevent="validateBeforeSubmit()"
      >
        <p class="register-required"><small>*</small>は必須項目です</p>

        <div class="form__group">
          <label class="form-label">
            メールアドレス
          </label>
          <p class="show-mail">{{ mail }}</p>
        </div>

        <InputText
          v-model="form.login_password"
          :vid="'login_password'"
          :label="'ログインパスワード'"
          :type="'password'"
          :placeholder="'*******'"
          :maxlength="20"
          :is-require="true"
          rules="required|min:6|max:20"
          class="form__group"
        />

        <InputText
          v-model="form.login_password_confirmation"
          :vid="'login_password_confirmation'"
          :label="'ログインパスワード再入力'"
          :type="'password'"
          :placeholder="'*******'"
          :maxlength="20"
          :is-require="true"
          rules="required|min:6|max:20|confirmed:login_password"
          class="form__group"
        />

        <InputText
          v-model="form.surname"
          :vid="'surname'"
          :label="'氏名（姓）'"
          :placeholder="'山田'"
          :maxlength="32"
          :is-require="true"
          rules="required|max:32"
          class="form__group"
        />

        <InputText
          v-model="form.first_name"
          :vid="'first_name'"
          :label="'氏名（名）'"
          :placeholder="'太郎'"
          :maxlength="32"
          :is-require="true"
          rules="required|max:32"
          class="form__group"
        />

        <InputText
          v-model="form.surname_kana"
          :vid="'surname_kana'"
          :label="'氏名カナ（セイ）'"
          :placeholder="'ヤマダ'"
          :maxlength="32"
          :is-require="true"
          rules="required|max:32|katakana"
          class="form__group"
        />

        <InputText
          v-model="form.first_name_kana"
          :vid="'first_name_kana'"
          :label="'氏名カナ（メイ）'"
          :placeholder="'タロウ'"
          :maxlength="32"
          :is-require="true"
          rules="required|max:32|katakana"
          class="form__group"
        />

        <InputText
          v-model="form.tel"
          :vid="'tel'"
          :label="'電話番号（ハイフン無し）'"
          :maxlength="11"
          :is-require="true"
          :placeholder="'09012345678'"
          rules="required|min:10|max:11|format_tel"
          class="form__group"
        />

        <div class="form__group postcode-wrapper">
          <InputText
            v-model="form.post_code"
            :vid="'post_code'"
            :label="'郵便番号（ハイフン無し）'"
            :maxlength="7"
            :is-require="true"
            :placeholder="'1500021'"
            rules="required|min:7|max:7|zipcode"
            class="form__group"
          />
          <div class="btn-wrapper">
            <Btn
              :label="'住所検索'"
              :color="'borderRed'"
              class="postcode-btn"
              @click.native="submitPostCode"
            />
          </div>
        </div>
        <p
          v-if="errAddress"
          class="form-valiTxt">
          {{ errAddress }}
        </p>

        <!--Input prefecture_id-->
        <ValidationProvider
          v-slot="{ errors }"
          class="form__group"
          tag="div"
          name="都道府県"
          rules="required">
          <label
            class="form-label"
            for="prefecture_id">都道府県<small>*</small></label>
          <select
            id="prefecture_id"
            v-model="form.prefecture_id"
            name="prefecture">
            <option
              :selected="form.prefecture_id === ''"
              :value="null"
            >
              選択なし
            </option>
            <option
              v-for="(item, index) in prefectures"
              :value="item.id"
              :key="index"
            >
              {{ item.name }}
            </option>
          </select>
          <span
            v-if="errors[0]"
            class="form-error">{{ errors[0] }}</span>
        </ValidationProvider>

        <InputText
          v-model="form.city_name"
          :vid="'city_name'"
          :label="'市区町村'"
          :maxlength="64"
          :is-require="true"
          :placeholder="'渋谷区'"
          rules="required|max:64"
          class="form__group"
        />

        <InputText
          v-model="form.address"
          :vid="'address'"
          :label="'番地・建物名'"
          :maxlength="64"
          :is-require="true"
          :placeholder="'渋谷'"
          rules="required|max:64"
          class="form__group"
        />

        <InputText
          v-model="form.birthday"
          :vid="'birthday'"
          :label="'生年月日'"
          :type="'date'"
          :placeholder="'1988 年 8 月 31日'"
          :note="'一度設定した生年月日は変更できません'"
          class="form__group"
        />

        <div class="form__group-check">
          <input
            v-model="checkboxTerm"
            type="checkbox"
          >
          <label class="form-label form-label-check">
            <a
              class="form-link"
              href="https://www.astro-p.co.jp/terms-of-service"
              target="_blank">利用規約</a>と<a
                class="form-link"
                href="https://www.astro-p.co.jp/privacypolicy"
                target="_blank">プライバシーポリシー</a>に同意する<small>*</small>
          </label>
        </div>

        <!-- Submit Button -->
        <div class="form__group mt40">
          <Btn
            :label="'確認'"
            :color="'red'"
            :disabled="invalid || isLoading || !checkboxTerm"
            :type="'submit'"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'
import searchAddress from '@/mixin/searchAddress.mixin'
import error from '@/mixin/error.mixin'
import store from '@/store'
import merge from 'deepmerge'

export default {
  name: 'AccountCreateStep03Form',

  mixins: [error, searchAddress],

  components: {
    mapGetters,
    InputText,
    Btn
  },

  computed: {
    ...mapGetters(['isLoading']),
    ...mapGetters('prefectures', ['prefectures']),
    ...mapGetters('accountCreate', ['mail'])
  },

  data () {
    return {
      prefecture_id: [],
      form: {
        login_password: '',
        login_password_confirmation: '',
        first_name: '',
        surname: '',
        first_name_kana: '',
        surname_kana: '',
        mail: '',
        birthday: '',
        post_code: '',
        prefecture_id: null,
        city_name: '',
        address: '',
        tel: ''
      },
      checkboxTerm: false,
      errAddress: null,
      formatDate: 'yyyy-mm-dd'
    }
  },

  beforeRouteEnter (from, to, next) {
    if (!store.getters['accountCreate/code_request_id']) {
      return next({name: 'AccountCreateStep01Mail'})
    }

    store.commit('loadingAction', false)
    next()
  },

  created () {
    const form = this.$store.getters['accountCreate/form']
    if (form) {
      this.form = merge(this.form, form)
    }

    this.getPrefectures()
  },

  watch: {
    // birthday
    'form.birthday': {
      handler (val) {
        if (!val) {
          this.formatDate = 'yyyy-mm-dd'
          return
        }
        this.formatDate = this.form.birthday
      },
      deep: true,
      immediate: true
    },
    'form.tel': {
      handler (val) {
        // input typeがnumberの場合maxlengthが効かないので桁数をwatchして制限
        if (val.length > 11) {
          this.form.tel = val.slice(0, 11)
        }
      },
      deep: true,
      immediate: true
    },
    'form.post_code': {
      handler (val) {
        // ハイフンが含まれている場合は自動で除去
        if (val && val.includes('-')) {
          this.form.post_code = val.replace(/-/g, '')
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.handleSubmit()
      }
    },

    handleSubmit () {
      this.$store.commit('accountCreate/setForm', this.form)
      this.$router.push({
        name: 'AccountCreateStep04Confirm'
      }).catch(() => {})
    },

    submitPostCode () {
      this.searchAddress(this.form.post_code).then(res => {
        if (res.status === 'ZERO_RESULTS') {
          this.errAddress = '該当する住所が存在しません'
          this.form.prefecture_id = ''
          this.form.city_name = ''
          this.form.address = ''
        } else {
          // 日本以外の国をチェック
          const isJapan = res.results[0].address_components.some(component =>
            component.types.includes('country') && component.long_name === '日本'
          )

          if (!isJapan || res.results[0].address_components.length === 1) {
            this.errAddress = '該当する住所が存在しません'
            this.form.prefecture_id = ''
            this.form.city_name = ''
            this.form.address = ''
            return
          }

          this.errAddress = null

          // 住所コンポーネントを格納する配列
          const addressParts = []
          res.results[0].address_components.forEach(val => {
            if (val.types.includes('administrative_area_level_1')) {
              this.form.prefecture_id = this.prefectures.find(item => val.long_name === item.name).id
            } else if (val.types.includes('locality')) {
              this.form.city_name = val.long_name
            } else if (val.types.includes('sublocality_level_1')) {
              // sublocality_level_1を先頭に追加するようにする
              if (addressParts.length === 0) {
                addressParts.push(val.long_name)
              } else {
                addressParts.unshift(val.long_name)
              }
            } else if (val.types.includes('sublocality_level_2')) {
              addressParts.push(val.long_name)
            }
          })
          // 住所部分を結合
          this.form.address = addressParts.join('')
        }
      }).catch(err => err)
    }
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/common.css';
  @import '../../assets/css/form.pcss';

  .register {
    height: 100%;
    overflow: auto;
    &-required {
      margin: 15px 0 34px;
      color: #d7000f;
    }
    & #prefecture_id {
      text-indent: 8px;
    }
    & .postcode-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 28px;
      .form__group {
        margin: 0;
      }
      & .btn-wrapper {
        width: 100%;
        max-width: 120px;
        margin-top: 28px;
        & .postcode-btn {
          max-width: 120px;
        }
      }
    }
    & input::-webkit-date-and-time-value {
      text-align: left;
    }
    & .show-mail {
      padding: 10px 0 0 0;
      word-break: break-all;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/account-create/Step03Form.vue